import config from "@/common/config/config";
import sendWithSM from './sendWithSM';
import http from "./https";

const win: any = window;

const httpCtx = http({
  baseUrl: config.API_BFF_URL + "/bff",
  // baseUrl: 'https://api-sit.mcdchina.net' + '/bff',
  isCheckTid: false,
});

const httpCtx2 = http({
  baseUrl: "https://people-api-sit.mcdchina.net",
  // baseUrl: 'https://api-sit.mcdchina.net' + '/bff',
  isCheckTid: false,
});

const httpCtxRelease = http({
  baseUrl: "https://api.mcd.cn/bff",
  isCheckTid: false,
});

const apis = {
  // 记录进群礼是否需要订阅接口
  record: (params: any) =>
    httpCtx.post(`/market/group/gift/record`, { params }),
  activityInvite: (activityCode: any) =>
    httpCtx.get(`/market/invite/activity/invite/${activityCode}`, {
      pathVars: [activityCode],
    }),
  activityAssistLaunch: (activityCode: any) =>
    httpCtx.get(`/market/assist/launch/${activityCode}`, {
      pathVars: [activityCode],
    }),
  activityConfig: (activityCode: any) =>
    httpCtx.get(`/market/activity/config/${activityCode}`, {
      pathVars: [activityCode],
    }),
  activityCarousel: (activityCode: any) =>
    httpCtx.get(`/market/invite/activity/carousel/${activityCode}`, {
      pathVars: [activityCode],
    }),
  activityAssistCarousel: (activityCode: any) =>
    httpCtx.get(`/market/assist/carousel/${activityCode}`, {
      pathVars: [activityCode],
    }),
  activityAssistPbz: (activityCode: any) =>
    httpCtx.get(`/market/assist/pbz/${activityCode}`, {
      pathVars: [activityCode],
    }),
  inviteRecord: (activityCode: any) =>
    httpCtx.get(`/market/invite/record/${activityCode}`, {
      pathVars: [activityCode],
    }),
  // 早餐卡邀请
  cardInvite: (taskId: any, headers: any) =>
    httpCtx.get(`/market/invite/task/${taskId}/basic`, {
      pathVars: [taskId],
      headers,
    }),
  cardInviteRecord: (taskId: any, headers: any) =>
    httpCtx.get(`/market/invite/task/${taskId}/data`, {
      pathVars: [taskId],
      headers,
    }),
  addCardInvite: (taskId: any, headers: any) =>
    httpCtx.post(`/market/invite/task/${taskId}/launch`, { headers }),
  acceptCardInviteBasic: (params: any, headers: any) =>
    httpCtx.get(`/market/invite/task/accept/basic`, { params, headers }),
  acceptCardInvite: (params: any, headers: any) =>
    httpCtx.get(`/market/task/invite/receive`, { params, headers }),
  getRewardDetail: (taskId: any, headers: any) =>
    httpCtx.get(`/market/invite/task/${taskId}/rewards`, {
      pathVars: [taskId],
      headers,
    }),
  // 绑定并登陆接口
  giftBind: (params: any) => httpCtx.post(`/passport/login/bind`, { params }),
  // 获取微信sign
  getWechatAuth: () => 
    httpCtxRelease.get(`/smaug/woaap/js/signature`, {
      params: {
        url: window.location.href,
      },
    }),
  // 领取进群礼
  giftReceive: (params: any, headers: any) =>
    httpCtx.post(`/market/group/gift/receive`, { params, headers }),
  // 查询是否可领取进群礼
  giftCheck: (params: any, headers: any) => httpCtx.get(`/market/group/gift/check`, { params, headers }),
  // 微信授权接口
  loginWx: (params: any) => httpCtx.post(`/passport/login/wx`, { params }),
  // 获取餐厅社区码接口
  giftQrCode: (params: any) =>
    httpCtx.get(`/market/group/join/index`, { params }),
  // 获取验证码接口 sendWithSM
  send: (params: any) => sendWithSM(httpCtx.send, `/passport/verifyCode/sms/send`, { 
    params: {
      ...params,
      vdata: win?.SMVdataSDK?.getVdata() || ''
    },
    method: 'post'
  }),

  // 登陆接口
  login: (params: any) => httpCtx.post(`/passport/login/mobile`, { params }),

  wecomLogin: (params: any) => httpCtx.post(`/market/wecom/login`, { params }),
  getWecomJsSignature: (params: any) =>
    httpCtx.get(`/market/wecom/js/signature`, { params }),
  getRgmRedpacketActivityList: (params: any, headers: any) =>
    httpCtx.get(`/market/rgm/activity/list`, { params, headers }),
  getRgmRedpacketList: (params: any, headers: any) =>
    httpCtx.get(`/market/rgm/redpacket/list`, { params, headers }),
  lockRgmRedpacket: (params: any, headers: any) =>
    httpCtx.post(`/market/rgm/redpacket/lock`, { params, headers }),
  bindRgmRedpacket: (params: any, headers: any) =>
    httpCtx.post(`/market/rgm/redpacket/bind`, { params, headers }),
  checkRgmRedpacketSend: (params: any, headers: any) =>
    httpCtx.get(`/market/rgm/redpacket/check`, { params, headers }),
  getCgmStoreList: (params: any, headers: any) =>
    httpCtx.get(`/market/clear/coupon/store/select`, { params, headers }),
  qrStoreJump: (params: any) =>
    httpCtx.get(`/portal/qr/store/jump`, { params }),
  generateQr: (params: any) =>
    httpCtx.get(`/bff/portal/qr/generate`, {
      params,
      baseUrl: config.API_BFF_URL,
    }),
  createPoster: (params: any, headers: any) =>
    httpCtx.get(`/market/app/poster/create/io`, {
      params,
      headers,
      responseType: "arraybuffer",
    }),
  queryStores: (params: any) => httpCtx.get(`/store/stores`, { params }),
  queryCity: (params: any) => httpCtx.get(`/store/cities`, { params }),
  queryStoreDetailByStoreCode: (storeCode: any) =>
    httpCtx.get(`/store/stores/address/${storeCode}`, {
      pathVars: [storeCode],
    }),
  updateLocation: (params: any) =>
    httpCtx.post(`/store/storeOps/updateLocation`, { params }),
  lotteryCheck: (params: any, headers: any) =>
    httpCtx.get(`/market/lottery/trade/check`, { params, headers }),
  lotteryTrade: (params: any, headers: any) =>
    httpCtx.post(`/market/lottery/trade`, { params, headers }),
  rewardRecord: (params: any, headers: any) =>
    httpCtx.get(`/market/achieve/list`, { params, headers }),
  queryDownloadImageSetting: (params: any, headers: any, ...rest: any[]) =>
    httpCtx.get("/portal/module/info", { params, headers, ...rest }),
  getCouponDetail: (params: any, headers: any) =>
    httpCtx.get(`/promotion/coupons/${params.id}`, {
      params: { couponId: params.couponId },
      pathVars: [params.id],
      headers,
    }),
  // https://api-docs.mcd.com.cn/project/659/interface/api/901682
  ccbLogin: (params: any) => httpCtx.post(`/passport/bcm/auth`, { params }),
  // https://api-docs.mcd.com.cn/project/659/interface/api/50650
  ccbLogout: (params: any) =>
    httpCtx.post(`/passport/user/cancel/logout`, { params }),
  // https://api-docs.mcd.com.cn/project/659/interface/api/90175
  ccbRegister: (code: any) =>
    httpCtx.post(`/passport/bcm/register`, { params: { code } }),

  // AKS获取活动状态 https://api-docs.mcd.com.cn/project/668/interface/api/113679
  getActivityStatus: (activityCode: any) =>
    httpCtx.get(`/market/lottery/common/basic`, { params: { activityCode } }),

  // AKS通用抽奖接口 https://api-docs.mcd.com.cn/project/668/interface/api/113735?
  drawForPrize: (params: any) =>
    httpCtx.post(`/market/lottery/common/pro/draw`, {
      params: {
        activityCode: params.activityCode,
        style: params.style,
      },
    }),

  // App专属接口
  appExclusive: (params: any) =>
    httpCtx.get(`/market/app/benefit/index`, { params }),

  // 神策数据短链
  jumpToApp: (params: any) =>
    httpCtx.post(`/market/api/tracking/create/shortUrl`, {
      params: {
        campaign: params.campaign,
        content: params.content,
        medium: params.medium,
        source: params.source,
        term: params.term,
        type: params.type,
      },
    }),

  getJumpWechatAuth: (params: any) =>
    httpCtx2.get(`/rct/portal/wx/jump/sign`, {
      params: {
        url: params.url,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
      },
    }),

  // 获取跳转地址url
  getNormalLink: (params: any) =>
    httpCtx.post(`/common/normal/link`, { params }),
  // 个性化落地页基础配置
  getIndividualizationpage: (params: any) =>
    httpCtx.post(`/mc/personal/landing/index`, {
      params,
    }),
  // FIFA领券落地页首页
  getFifaCouponPageIndex: (params: any, headers?: any) =>
    httpCtx.get(`/market/api/fifa/coupon/page/index`, {
      params,
      headers,
    }),
  // FIFA领券落地页领取绑定
  bindFifaCouponPage: (params: any, headers?: any) =>
    httpCtx.post(`/market/api/fifa/coupon/page/binding`, {
      params,
      headers,
    }),
  // 点击领取券
  bindIndividualizationCoupon: (params: any) =>
    httpCtx.post(`/mc/personal/landing/bind`, {
      params,
    }),
  
  // 无笼好鸡分享页主接口
  getCfcBaseConfig: (params: Record<string, string|number>) =>
    httpCtx.get(`/journey/stepChicken/index`, {
      params,
    }),

  getCfcShareConfig: (params: Record<string, string|number>) =>
    httpCtx.get(`/journey/stepChicken/share`, {
      params,
    }),

  // GitHub授权配置接口
  getGitHubAuthConfig: (params: any, headers: any) =>
    httpCtx.get(`/member/api/v1/github-auth/info`, { params, headers }),

  // GitHub领券接口
  receiveCoupon: (params: any, headers: any) =>
    httpCtx.post(`/member/api/v1/github-auth/claim-reward`, { params, headers }),

  // code绑定麦当劳账号
  bindCode: (params: any, headers: any) =>
    httpCtx.post(`/passport/account/github/bind`, { params, headers }),
  getSkillRank: () =>
    httpCtx.get(`/market/code/mcp/skill/ranking`, {}),
};

export default apis;
